import { render, staticRenderFns } from "./AddVendor.vue?vue&type=template&id=615b7012&scoped=true&"
import script from "./AddVendor.vue?vue&type=script&lang=js&"
export * from "./AddVendor.vue?vue&type=script&lang=js&"
import style0 from "./AddVendor.vue?vue&type=style&index=0&id=615b7012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615b7012",
  null
  
)

component.options.__file = "AddVendor.vue"
export default component.exports